<template>
  <section class="register-2">
    <div class="container-scroller">
      <div class="container-fluid page-body-wrapper full-page-wrapper p-0">
        <div
          class="content-wrapper d-flex align-items-stretch auth auth-img-bg"
          style="overflow: hidden"
        >
          <div class="row flex-grow">
            <div
              class="col-lg-5 activation-password-form-left d-flex align-items-center justify-content-center"
            >
              <div class="brand-logo auth-form-transparent col-md-12 col-lg-9">
                <router-link :to="{ name: 'SmartOeeLogin' }">
                  <img :src="require('@/assets/images/logo3.png')" alt="logo" />
                </router-link>
              </div>
              <div class="w-75 pt-5 pt-md-0">
                <div
                  class="auth-form-transparent text-left pt-5 pt-md-0 px-0 ml-0 col-md-12 col-lg-9"
                >
                  <h3 class="mb-5">{{ $t('resetPwd.activation.title') }}</h3>
                  <p>{{ $t('resetPwd.activation.body') }}</p>
                  <b-button
                    class="btn-block btn-primary btn-lg font-weight-medium mb-3 mb-md-0"
                    variant="primary"
                    @click="goToLogin()"
                  >
                    {{ $t('resetPwd.activation.buttonText') }}
                  </b-button>
                </div>
              </div>
            </div>
            <div
              class="col-lg-7 col-md-12 login-half-bg d-flex align-items-center justify-content-center"
            >
              <text-for-login-register-page></text-for-login-register-page>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ActivationPassword',
  methods: {
    goToLogin() {
      this.$router.push({ name: 'SmartOeeLogin' });
    },
  },
};
</script>
<style lang="scss" scoped>
.activation-password-form-left {
  position: relative;
  background-color: #191c24;
  .brand-logo {
    position: absolute;
    top: 35px;
  }
}
.custom-size-16 {
  font-size: 16px;
}
@media (max-width: 767.9px) {
  .activation-password-form-left {
    .brand-logo {
      left: 10%;
    }
  }
}
</style>
